import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditMyCompanyMemberEmploymentTimeOffGroupWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  convertCompensatoryDaysToMinutes,
  convertMinutesToCompensatoryDays,
  convertMinutesToHours,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils.js';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification.js';
import * as _ from 'lodash';
import EditDataIcon from '../assets/images/edit-specification-code-64x64.svg';
import {
  readCompanyMember,
  updateCompanyMemberEmploymentTermsTimeOffData,
} from '../redux/actions/table/my_company_members.js';
import EditMyCompanyMemberEmploymentTimeOffGroupForm from '../forms/edit_my_company_member_employment_time_off_group_wizard/EditMyCompanyMemberEmploymentTimeOffGroupForm.js';
import EditMyCompanyMemberEmploymentTimeOffFutureGroupForm from '../forms/edit_my_company_member_employment_time_off_group_wizard/EditMyCompanyMemberEmploymentTimeOffFutureGroupForm.js';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'my_company_members'),
}))
@withRouter
class EditMyCompanyMemberEmploymentTimeOffGroupWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '01',
      steps: [
        {
          id: '01',
          title: __('wizard.my-company-members.title.time-off-current-group'),
        },
        {
          id: '02',
          title: __('wizard.my-company-members.title.time-off-future-group'),
        },
      ],
    };
  }
  @autobind
  _setActiveStep(id) {
    this.setState({ active: id });
  }
  @autobind
  _handleSubmitCurrent(formData) {
    const { store } = this.props;

    let data = {
      user_id: store.flyout.details.id,
      vacation_days_base: formData?.vacation_days_base,
      minutes_off_base: convertCompensatoryDaysToMinutes(
        formData?.minutes_off_base
      ),
      time_off_start_date: formData?.time_off_start_date,
      time_off_end_date: formData?.time_off_end_date,
    };

    return validateForm(
      updateCompanyMemberEmploymentTermsTimeOffData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __(
                'my-company-members.employment-terms.current-time-off-group.updated'
              )
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  @autobind
  _handleSubmitFuture(formData) {
    const { store } = this.props;

    let data = {
      user_id: store.flyout.details.id,
      vacation_days_base: formData?.vacation_days_base,
      minutes_off_base: convertCompensatoryDaysToMinutes(
        formData?.minutes_off_base
      ),
      time_off_start_date: formData?.time_off_start_date,
      time_off_end_date: formData?.time_off_end_date,
      is_new: true,
    };

    return validateForm(
      updateCompanyMemberEmploymentTermsTimeOffData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __(
                'my-company-members.employment-terms.future-time-off-group.updated'
              )
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  render() {
    const { employmentTimeOffData } = this.props.store;

    const { steps, active } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.title}>
            <div className={styles.left}>
              <span>
                {__(
                  'wizard.my-company-members.title.edit-my-company-member-employment-time-off-group'
                )}
              </span>
              <span>
                {__(
                  'wizard.my-company-members.subtitle.edit-my-company-member-employment-time-off-group'
                )}
              </span>
            </div>
            <div className={styles.right}>
              <EditDataIcon />
            </div>
          </div>
          <div className={styles.steps}>
            {_.map(steps, (step, i) => (
              <div
                key={i}
                onClick={() => this._setActiveStep(step.id)}
                className={`
                ${styles.step} 
                ${active === step.id ? styles.active : ''}
              `}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>{' '}
        </div>

        {/* TAB CONTENT */}
        <div className={styles.body}>
          {active === '01' && (
            <EditMyCompanyMemberEmploymentTimeOffGroupForm
              onSubmit={this._handleSubmitCurrent}
              initialValues={{
                vacation_days_base:
                  employmentTimeOffData?.data?.current?.vacation_days_base ||
                  null,
                minutes_off_base:
                  convertMinutesToCompensatoryDays(
                    employmentTimeOffData?.data?.current?.minutes_off_base
                  ) || null,
                last_year_vacation_days:
                  employmentTimeOffData?.data?.current
                    ?.last_year_vacation_days || null,
                used_vacation_days:
                  employmentTimeOffData?.data?.current?.used_vacation_days ||
                  null,
                used_minutes_off:
                  convertMinutesToCompensatoryDays(
                    employmentTimeOffData?.data?.current?.used_minutes_off
                  ) || null,
                vacation_days_remaining:
                  employmentTimeOffData?.data?.current
                    ?.vacation_days_remaining || null,
                available_compensatory_hours:
                  convertMinutesToHours(
                    employmentTimeOffData?.data?.current
                      ?.available_compensatory_minutes
                  ) || null,
                time_off_start_date:
                  employmentTimeOffData?.data?.current?.time_off_start_date ||
                  null,
                time_off_end_date:
                  employmentTimeOffData?.data?.current?.time_off_end_date ||
                  null,
              }}
            />
          )}

          {active === '02' && (
            <EditMyCompanyMemberEmploymentTimeOffFutureGroupForm
              onSubmit={this._handleSubmitFuture}
              initialValues={{
                vacation_days_base:
                  employmentTimeOffData?.data?.future?.vacation_days_base ||
                  null,
                minutes_off_base:
                  convertMinutesToCompensatoryDays(
                    employmentTimeOffData?.data?.future?.minutes_off_base
                  ) || null,
                last_year_vacation_days:
                  employmentTimeOffData?.data?.future
                    ?.last_year_vacation_days || null,
                used_vacation_days:
                  employmentTimeOffData?.data?.future?.used_vacation_days ||
                  null,
                used_minutes_off:
                  convertMinutesToCompensatoryDays(
                    employmentTimeOffData?.data?.future?.used_minutes_off
                  ) || null,
                vacation_days_remaining:
                  employmentTimeOffData?.data?.future
                    ?.vacation_days_remaining || null,
                available_compensatory_hours:
                  convertMinutesToHours(
                    employmentTimeOffData?.data?.future
                      ?.available_compensatory_minutes
                  ) || null,
                time_off_start_date:
                  employmentTimeOffData?.data?.future?.time_off_start_date ||
                  null,
                time_off_end_date:
                  employmentTimeOffData?.data?.future?.time_off_end_date ||
                  null,
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default EditMyCompanyMemberEmploymentTimeOffGroupWizard;
